import { render, staticRenderFns } from "./Layering.vue?vue&type=template&id=1c477949"
import script from "./Layering.vue?vue&type=script&lang=js"
export * from "./Layering.vue?vue&type=script&lang=js"
import style0 from "./Layering.vue?vue&type=style&index=0&id=1c477949&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports